module.exports = __webpack_public_path__ + "img/image-004.2e6abaa9.png";